/**
 * Brand Sanitizer — runtime DOM guard that removes any third-party
 * authoring/badge artifacts so VerseSport™ presents as fully
 * proprietary software of Inneli Technology Corp. PBC.
 */
const FORBIDDEN_TEXT = ["edit with lovable", "built with lovable", "powered by lovable"];
const FORBIDDEN_SELECTORS = [
  '[href*="lovable" i]',
  '[src*="lovable" i]',
  "[data-lovable]",
  '[class*="lovable" i]',
  '[id*="lovable" i]',
  "#lovable-badge",
  "lovable-badge",
];

function nuke(el: Element) {
  try {
    (el as HTMLElement).style.setProperty("display", "none", "important");
    el.remove();
  } catch {
    /* noop */
  }
}

function sweep(root: ParentNode = document) {
  for (const sel of FORBIDDEN_SELECTORS) {
    let nodes: NodeListOf<Element> | null = null;
    try {
      nodes = root.querySelectorAll(sel);
    } catch {
      continue;
    }
    nodes.forEach(nuke);
  }
  // Text-based match (badge labels that don't carry class/id hints)
  const walker = document.createTreeWalker(root as Node, NodeFilter.SHOW_TEXT);
  const toKill: Element[] = [];
  let n: Node | null = walker.nextNode();
  while (n) {
    const txt = (n.nodeValue || "").toLowerCase();
    if (FORBIDDEN_TEXT.some((p) => txt.includes(p))) {
      const host = (n.parentElement?.closest("a,button,div,span,section,aside,footer") || n.parentElement) as Element | null;
      if (host) toKill.push(host);
    }
    n = walker.nextNode();
  }
  toKill.forEach(nuke);
}

let started = false;
export function startBrandSanitizer() {
  if (started || typeof window === "undefined") return;
  started = true;
  const run = () => sweep(document);
  run();
  const obs = new MutationObserver(() => run());
  obs.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
  window.addEventListener("load", run);
}